import { render, staticRenderFns } from "./batchManageView.vue?vue&type=template&id=5c95db2e&"
import script from "./batchManageView.vue?vue&type=script&lang=js&"
export * from "./batchManageView.vue?vue&type=script&lang=js&"
import style0 from "./batchManageView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports